<template>
  <div>
    <subcategory-markup
      class="body-bg-color"
      :style="[customCss]"
      :courseSettings="courseSettings"
    >
      <template slot="header" v-if="isPreview">
        <subcategory-header :getThemeSettings="getThemeSettings">
          <template slot="logo">
            <header-logo
              v-if="isPreview"
              :logoPath="membershipMasterData.logo"
              :logoSize="membershipMasterData.logo_size"
              :altText="'Header Logo'"
            ></header-logo>
          </template>
          <template slot="menus">
            <menu-items
              :isPreview="isPreview"
              :position="'header'"
              :activeMenus="activeHeaderMenu"
              :sendToPath="sendToPath"
            ></menu-items>
          </template>
          <template slot="profile" v-if="user">
            <header-profile
              :user="user"
              :openProfilePopup="openProfilePopup"
              :logoutUser="logoutUser"
              :isPortal="isPortal"
              :backPortalPage="backPortalPage"
              :profileLabel="membershipMasterData.gen_settings && JSON.parse(membershipMasterData.gen_settings).profile_label"
             :logoutLabel="membershipMasterData.gen_settings &&  JSON.parse(membershipMasterData.gen_settings).logout_label"
            ></header-profile>
          </template>
          <template slot="button" v-else>
            <subcategory-button
              :buttonText="'Log In'"
              :buttonCallback="() => {}"
              :callbackParam="1"
              :specialHover="1"
              :getThemeSettings="getThemeSettings"
            ></subcategory-button>
          </template>
        </subcategory-header>
      </template>
      <template slot="hero">
        <subcategory-banner
          :overlayColor="
            activeElement.value.configuration_options.overlay_color
          "
          :showBanner="activeElement.value.show_banner"
          :bannerType="activeElement.value.banner_type"
        >
          <template slot="avatar">
            <banner-avatar
              :isPreview="isPreview"
              :calledFrom="`subcategory`"
              :featuredImage="activeElement.value.featured_image"
              :featuredVideoEmbed="activeElement.value.featured_video"
              :overlayColor="
                activeElement.value.configuration_options.overlay_color
              "
              :updateFeaturedImage="updateBannerFeaturedImage"
              :updateFeaturedVideo="updateBannerFeaturedVideo"
              :updateOverlay="updateBannerOverlayColor"
              :updateType="updateBannerType"
              :bannerSettings="activeElement.value.configuration_options"
            ></banner-avatar>
          </template>
          <template slot="story">
            <banner-story>
              <template slot="title">
                <banner-title
                  :text="activeElement.value.name_markup"
                  :updateTitle="updateBannerTitle"
                  :isPreview="isPreview"
                ></banner-title>
              </template>
              <template slot="description">
                <banner-description
                  :text="activeElement.value.description_markup"
                  :updateDescription="updateBannerDescription"
                  :isPreview="isPreview"
                ></banner-description>
              </template>
            </banner-story>
          </template>
        </subcategory-banner>
      </template>
      <template slot="breadcrumb">
        <!-- <filters class="membership-layout-container"></filters> -->
        <breadcrumb
          :isPreview="isPreview"
          :hierarchy="hierarchy"
          :activeElement="activeElement"
          :activateElement="activateElement"
          :sendToPath="sendToPath"
          :getThemeSettings="getThemeSettings"
          :courseSettings="courseSettings"
          :getHomeMenuData="getHomeMenuData"
        ></breadcrumb>
      </template>
      <template slot="course">
        <div v-if="listElements.length > 0" class="w-full md:w-8/12">
          <subcategory-courses
            :listElements="listElements"
            :getThemeSettings="getThemeSettings"
          >
            <template slot="title">
              <div class="body-heading-color inter-font-bold">
                {{ activeElement.value.name }}
              </div>
            </template>
            <template slot="courses-list">
              <course-tile
                v-for="(category, index) in listElements"
                :key="index"
                :getThemeSettings="getThemeSettings"
                :showProgressbar="courseSettings.show_progressbar"
              >
                <template slot="course-tile-image">
                  <div
                    @click="
                      !isPreview
                        ? activateElement({ e: '', el: category })
                        : sendToPath({
                            name: 'post',
                            params: { id: category.slug },
                          })
                    "
                    class="tile-img cursor-pointer mr-4"
                  >
                    <img
                      v-if="category.featured_image"
                      class="w-full h-20 object-cover rounded-lg"
                      :src="category.featured_image"
                    />
                    <div
                      v-else
                      class="no-image-tile-v2 bg-tile-red text-white text-sm font-bold items-center text-center flex w-full h-20 rounded-lg justify-center mb-1"
                    >
                      {{ category.name }}
                    </div>
                    <!-- <div>Total Lessons: {{ getTotalLessons(category) }}</div>
                    <div>
                      Completed Lessons: {{ getCompletedLessons(category) }}
                    </div> -->
                  </div>
                </template>
                <template slot="course-tile-title">
                  <span
                    class="cursor-pointer inter-font-bold"
                    @click="
                      !isPreview
                        ? activateElement({ e: '', el: category })
                        : sendToPath({
                            name: 'post',
                            params: { id: category.slug },
                          })
                    "
                    >{{ category.name }}
                  </span>
                </template>
                <template slot="course-tile-description">
                  <span
                    class="cursor-pointer"
                    @click="
                      !isPreview
                        ? activateElement({ e: '', el: category })
                        : sendToPath({
                            name: 'post',
                            params: { id: category.slug },
                          })
                    "
                    >{{ category.description }}</span
                  >
                </template>
                <template slot="course-tile-progress-bar">
                  <custom-tick
                    v-if="category.type === 'post' && category.is_completed"
                    :getThemeSettings="getThemeSettings"
                  ></custom-tick>
                  <progress-bar
                    v-else
                    :label="0"
                    :completed="getCompletedLessons(category)"
                    :total="getTotalLessons(category)"
                    :getThemeSettings="getThemeSettings"
                  >
                  </progress-bar>
                </template>
                <template slot="course-tile-type">
                  <div
                    @click="
                      !isPreview
                        ? activateElement({ e: '', el: category })
                        : sendToPath({
                            name: 'post',
                            params: { id: category.slug },
                          })
                    "
                    class="cursor-pointer inter-font-regular w-full h-full flex justify-center items-center"
                  >
                    <span v-if="category.type == 'category' && courseSettings.gen_settings && courseSettings.gen_settings.viewModuleLabel">{{courseSettings.gen_settings.viewModuleLabel}}</span>

                    <span v-if="category.type == 'subcategory' && courseSettings.gen_settings && courseSettings.gen_settings.viewChapterLabel"
                      >{{courseSettings.gen_settings.viewChapterLabel}}</span
                    >

                    <span v-if="category.type == 'post' && courseSettings.gen_settings && courseSettings.gen_settings.viewLessonLabel">{{courseSettings.gen_settings.viewLessonLabel}}</span>
                  </div>
                </template>
              </course-tile>
            </template>
          </subcategory-courses>
        </div>
        <div
          v-if="listElements.length < 1 && !isPreview"
          class="w-full md:w-8/12"
        >
          <empty-cat
            :allowed="['post']"
            :triggerAddNewHirearchyItem="triggerAddNewHirearchyItem"
          ></empty-cat>
        </div>
      </template>
      <template slot="right-sidebar">
        <subcategory-sidebar
          :showSidebarImg="courseSettings.show_sidebar_img"
          :showProgressbar="courseSettings.show_progressbar"
        >
          <template slot="featured-image">
            <sidebar-featured-image
              :isPreview="isPreview"
              :src="activeElement.value.sidebar_image"
              :name="activeElement.value.name"
              :getThemeSettings="getThemeSettings"
              :avatar="activeElement.value.sidebar_image"
              :businessNiche="'Business'"
              :updateFeaturedImage="updateSidebarFeaturedImage"
            ></sidebar-featured-image>
          </template>
          <template slot="featured-description">
            <sidebar-featured-description
              :isPreview="isPreview"
              :text="activeElement.value.sidebar_description"
              :updateDescription="updateSidebarDescription"
              :getThemeSettings="getThemeSettings"
            ></sidebar-featured-description>
          </template>
          <template slot="progress-bar">
            <progress-bar
              :label="progressBarLabel"
              :completed="completedLessons"
              :total="totalLessons"
              :getThemeSettings="getThemeSettings"
            >
            </progress-bar>
          </template>
        </subcategory-sidebar>
      </template>
      <template slot="footer" v-if="isPreview">
        <subcategory-footer :getThemeSettings="getThemeSettings">
          <template slot="logo">
            <footer-logo
              v-if="isPreview"
              :logoPath="membershipMasterData.footer_logo"
              :altText="'Footer Logo'"
              :logoSize="membershipMasterData.footer_logo_size"
            ></footer-logo>
          </template>
          <template slot="menus">
            <menu-items
              :isPreview="isPreview"
              :position="'footer'"
              :activeMenus="activeFooterMenu"
              :sendToPath="sendToPath"
            ></menu-items>
          </template>
        </subcategory-footer>
      </template>
    </subcategory-markup>
  </div>
</template>
<script>
import SubcategoryMarkup from './subcategory-markup';

import SubcategoryHeader from '../../../common/header/header';
import HeaderLogo from '../../../common/header/logo';
import HeaderProfile from '../../../common/header/profile';

import SubcategoryBanner from '../../../common/banner/banner';
import BannerAvatar from '../../../common/banner/avatar/avatar';
import BannerStory from '../../../common/banner/story/story';
import BannerTitle from '../../../common/banner/story/title';
import BannerDescription from '../../../common/banner/story/description';
import SubcategoryCourses from '../../../common/courses/courses-v-2';
import CourseTile from '../../../common/tile/tile-v-2';

import SidebarFeaturedImage from '../../../common/featuredImage';
import SidebarFeaturedDescription from '../../../common/featuredDescription';
import SubcategorySidebar from '../../../common/sidebar/rightSidebar';

import ProgressBar from '../../../common/progressBar';
import CustomTick from '../../../common/customTick';

import SubcategoryFooter from '../../../common/footer/footer';
import FooterLogo from '../../../common/footer/logo';

import SubcategoryButton from '../../../common/button';
import MenuItems from '../../../common/menuItems';
import Breadcrumb from '../../../common/breadcrumb';
import EmptyCat from '../../../common/emptyCat';

import {
  getTotalLessons,
  getCompletedLessons,
} from '../../../../../helpers/totalVsCompleted';

export default {
  name: 'CategoryTemplate',
  data() {
    return {
      getTotalLessons,
      getCompletedLessons,
    };
  },
  components: {
    SubcategoryMarkup,
    SubcategoryHeader,
    HeaderLogo,
    HeaderProfile,
    SubcategoryBanner,
    BannerAvatar,
    BannerStory,
    BannerTitle,
    BannerDescription,
    SubcategoryCourses,
    CourseTile,
    ProgressBar,
    CustomTick,
    SubcategorySidebar,
    SidebarFeaturedImage,
    SidebarFeaturedDescription,
    SubcategoryFooter,
    FooterLogo,
    SubcategoryButton,
    MenuItems,
    Breadcrumb,
    EmptyCat,
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: null,
    },
    openProfilePopup: {
      type: Function,
      default: () => {},
    },
    logoutUser: {
      type: Function,
      default: () => {},
    },
    triggerAddNewHirearchyItem: {
      type: Function,
      default: () => {},
    },
    hierarchy: {},
    activeElement: {},
    activateElement: {
      type: Function,
      default: () => {},
    },
    sendToPath: {
      type: Function,
      default: () => {},
    },
    activeHeaderMenu: {
      type: Array,
      default: () => [],
    },
    activeFooterMenu: {
      type: Array,
      default: () => [],
    },
    updateBannerTitle: {
      type: Function,
      default: () => {},
    },
    updateBannerDescription: {
      type: Function,
      default: () => {},
    },
    updateBannerFeaturedImage: {
      type: Function,
      default: () => {},
    },
    updateBannerFeaturedVideo: {
      type: Function,
      default: () => {},
    },
    updateBannerOverlayColor: {
      type: Function,
      default: () => {},
    },
    updateBannerType: {
      type: Function,
      default: () => {},
    },
    getThemeSettings: {},
    membershipMasterData: {},
    totalLessons: {
      required: true,
    },
    updateSidebarFeaturedImage: {
      type: Function,
      default: () => {},
    },
    updateSidebarDescription: {
      type: Function,
      default: () => {},
    },
    completedLessons: {
      required: true,
    },
    isPortal: {
      type: Boolean,
      default: false,
    },
    backPortalPage: {
      type: Function,
      default: () => {},
    },
    courseSettings: {},
  },
  computed: {
    getHomeMenuData() {
        return this.activeHeaderMenu.find(item => item.is_default==1);
    },
    listElements() {
      return this.activeElement.value.children.filter((el) => !el.is_hidden);
    },
    progressBarLabel() {
      return `${this.completedLessons} of ${this.totalLessons} lessons completed`;
    },
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--template-body-bg-color': this.themeSettings.body_section.bg_color,
        '--template-section-bg-color': this.themeSettings.configuration_options
          .section_bg_color,
        '--template-section-content-color': this.themeSettings
          .configuration_options.section_content_color,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.body-bg-color {
  background-color: var(--template-body-bg-color);
}
</style>